import getApiClient from '@/plugins/api-client'

export default {
    loadProfile() {
        const self = this,
            api = getApiClient(self.$store),
            profileId = self.$route.params.id

        if (['xs', 'sm', 'md'].includes(self.$vuetify.breakpoint.name)) {
            self.$vuetify.goTo(0)
        }

        api.get(`/work_profiles/${profileId}`)
            .then(result => {
                self.profile = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },

    backToSearch() {
        this.$router.push({
            name: 'CastSearch'
        })
    },

    goToJobCreation() {
        this.$router.push({
            name: 'ContractorJobForm'
        })
    },

    showMedia(media, index) {
        this.showZoomMedia = true
        this.zoomMedia = media
        this.currentMedia = index
    },

    closeMedia() {
        this.zoomMedia = null
        this.showZoomMedia = false
    },

    toggleFavorite(id) {
        const self = this,
            api = getApiClient(self.$store)

        let favorites = self.$store.state.session.favoriteWorkProfiles,
            favoriteIds = favorites.map(profile => {
                return profile['@id']
            })

        if (!favoriteIds.includes(id)) {
            favoriteIds.push(id)
        } else {
            favoriteIds = favoriteIds.filter(profileId => {
                return profileId !== id
            })
        }

        api.patch(`/contractor/favorite_workprofiles/${self.$store.state.session.user.id}`, {favoriteWorkProfiles: favoriteIds}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.$store.commit('setFavoriteWorkProfiles', result.data.favoriteWorkProfiles['hydra:member'])
            })
            .catch(error => {
                console.log(error)
            })
    },

    getPastJobTypeLabel(type) {
        let item = this.allAvailableJobTypes.filter(item => {
            return item.code === type
        })

        return item[0]?.label ?? type
    },

    getLanguageLabel(language) {
        let item = this.availableLanguages.filter(item => {
            return item.value === language
        })

        return item[0]?.label ?? language
    },

    getEducationLevelLabel(level) {
        let item = this.availableEducationLevels.filter(item => {
            return item.value === level
        })

        return item[0]?.label ?? level
    },

    exportProfile() {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`users/pdf/${self.profile.user.id}`, {responseType: 'blob'})
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data])),
                    link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `${self.profile.user.name} - Perfil na Castfy.pdf`)
                document.body.appendChild(link)
                link.click()
            })
            .catch(error => {
                console.log(error)
            })
    },


    showCompletedCourseDetails(course) {
        this.completedCourseDetails = {
            ...course,
            show: true
        }
    },

    hideCompletedCourseDetails() {
        this.completedCourseDetails = {
            show: false,
            image: null,
            name: null,
            description: null
        }
    },
}
